module.exports = __webpack_public_path__ + "static/img/mentor-siemens_white.046491f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/mentor-siemens_white.svg
// module id = Y3tK
// module chunks = 1